<template>
  <div>
    <div class="vm-search" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
      <div style="position: relative; display: flex;align-items: center">
        <el-date-picker
            v-model="filter.beginTime"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 150px;margin-right: 5px"
            placeholder="选择报表月份"/>
        <el-select v-model="filter.reportType" style="width: 130px;margin-right: 5px" placeholder="报表类型">
          <el-option :value="1" label="年度累计"/>
          <el-option :value="2" label="月度"/>
        </el-select>
        <el-button
            :loading="status==='loading'"
            type="primary"
            size="mini"
            style="height: 26px; padding: 0 10px; margin-left: 10px;"
            @click="getList">
          查询
        </el-button>
        <el-button :loading="downLoadLoading" type="primary" size="mini" @click="downLoadFile">下载</el-button>
        <el-button type="success" size="mini" @click="openDownload">下载明细</el-button>
      </div>
      <div>
        <el-dropdown trigger="click" style="margin-right: 8px" @command="handleCommand">
          <el-button type="primary" size="mini">
            数据维护<i class="el-icon-arrow-down el-icon--right"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pendingOrder">区总待下单填写</el-dropdown-item>
            <el-dropdown-item v-if="$auth(954)" command="manualEdit">财务手工编辑</el-dropdown-item>
            <el-dropdown-item divided command="editLog">修改记录台账</el-dropdown-item>
            <el-dropdown-item command="adjustLog">区域调整台账</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown trigger="click" style="margin-right: 8px" @command="handleCommand">
          <el-button type="primary" size="mini">
            销售数据导入<i class="el-icon-arrow-down el-icon--right"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="bpImport">BP/预测 导入</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown trigger="click" style="margin-right: 8px" @command="handleCommand">
          <el-button type="primary" size="mini">
            客户换算设置<i class="el-icon-arrow-down el-icon--right"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logisticsCycle">客户物流周期设置</el-dropdown-item>
            <el-dropdown-item command="zeroOrder">零元订单暂估设置</el-dropdown-item>
            <el-dropdown-item command="relatedRatio">关联客户暂估比例设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-button type="danger" size="mini" @click="openExclude">发货单异常剔除</el-button>
        <el-button type="warning" size="mini" @click="openExcludeLog">剔除记录</el-button>
      </div>
    </div>
    <el-table
        ref="table"
        v-loading="status==='loading'"
        :data="tableData"
        style="width: 100%"
        row-key="pkId"
        height="calc(100vh - 20vh)"
        border
        :row-style="summaryRowStyle"
        :row-class-name="summaryRowClassName"
        :tree-props="{children: 'children'}"
        @cell-mouse-enter="handleCellMouseEnter"
        @cell-mouse-leave="handleCellMouseLeave">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="getList">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column prop="orgName" min-width="180" align="center" label="组织名称"/>
      <el-table-column prop="bpTarget" align="center" label="BP目标"/>
      <el-table-column property="originalSignedAmount" align="center" label="已签收" width="140">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.signedAmountDetails)" class="amount-link" @click="openDetail('已签收金额', scope.row.signedAmountDetails)">{{scope.row.originalSignedAmount}}</span>
          <span v-else>{{scope.row.originalSignedAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column property="signedAmount" align="center" label="已签收(调整后)" width="180">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.signedAmountDetails)" :class="scope.row.signedAdjusted ? 'amount-link adjust-red' : 'amount-link'" @click="openDetail('已签收金额(调整后)', scope.row.signedAmountDetails)">{{scope.row.signedAmount}}</span>
          <span v-else :class="{ 'adjust-red': scope.row.signedAdjusted }">{{scope.row.signedAmount}}</span>
          <el-button
              v-if="$auth(713) && isAdjustableRow(scope.row) && hoverRow === scope.row"
              type="primary"
              plain
              size="mini"
              style="margin-left: 6px"
              @click.stop="openRegionalAdjust(scope.row)">修改</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="bpDiff" align="center" label="BP差"/>
      <el-table-column prop="bpDiffRate" align="center" label="BP差率"/>
      <el-table-column prop="samePeriodAmount" align="center" label="同期数据"/>
      <el-table-column prop="samePeriodDiff" align="center" label="同期差"/>
      <el-table-column prop="samePeriodRate" align="center" label="同期差率"/>
      <el-table-column align="center" label="已发运未签收" width="120">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.shippedUnsignedAmountDetails)" class="amount-link" @click="openDetail('已发运未签收金额', scope.row.shippedUnsignedAmountDetails)">{{scope.row.shippedUnsignedAmount}}</span>
          <span v-else>{{scope.row.shippedUnsignedAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已排产未发运" width="120">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.producedUnshippedAmountDetails)" class="amount-link" @click="openDetail('已排产未发运金额', scope.row.producedUnshippedAmountDetails)">{{scope.row.producedUnshippedAmount}}</span>
          <span v-else>{{scope.row.producedUnshippedAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已排产已提交" width="120">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.producedSubmittedAmountDetails)" class="amount-link" @click="openDetail('已排产发货单已提交金额', scope.row.producedSubmittedAmountDetails)">{{scope.row.producedSubmittedAmount}}</span>
          <span v-else>{{scope.row.producedSubmittedAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已下单未排产" width="120">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.orderedUnproducedAmountDetails)" class="amount-link" @click="openDetail('已下单未排产金额', scope.row.orderedUnproducedAmountDetails)">{{scope.row.orderedUnproducedAmount}}</span>
          <span v-else>{{scope.row.orderedUnproducedAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pendingOrderAmount" align="center" label="待下单"/>
      <el-table-column prop="bpGuaranteeAmount" align="center" label="BP保障度"/>
      <el-table-column prop="bpGuaranteeDiff" align="center" label="与BP差"/>
      <el-table-column prop="bpGuaranteeRate" align="center" label="与BP差率"/>
      <el-table-column prop="forecastAmount" align="center" label="预测"/>
      <el-table-column align="center" label="已下单" width="110">
        <template slot-scope="scope">
          <span v-if="hasDetail(scope.row.monthOrderedAmountDetails)" class="amount-link" @click="openDetail('已下单', scope.row.monthOrderedAmountDetails)">{{scope.row.monthOrderedAmount}}</span>
          <span v-else>{{scope.row.monthOrderedAmount}}</span>
        </template>
      </el-table-column>
    </el-table>

    <pending-order-edit ref="pendingOrderEdit" @save-success="getList"/>
    <manual-edit-dialog ref="manualEdit"/>
    <regional-adjust-edit ref="regionalAdjust" @save-success="getList"/>
    <edit-log-dialog ref="editLog"/>
    <adjust-log-dialog ref="adjustLog" @deleted="getList"/>
    <bp-import-dialog ref="bpImport"/>
    <logistics-cycle-dialog ref="logisticsCycle"/>
    <zero-order-dialog ref="zeroOrder"/>
    <related-ratio-dialog ref="relatedRatio"/>
    <exclude-import-dialog ref="exclude"/>
    <exclude-log-dialog ref="excludeLog"/>
    <sales-revenue-detail-dialog ref="detailDialog"/>
    <sales-revenue-detail-download ref="downloadDialog"/>
  </div>
</template>

<script>
  import dateUtil from "@/util/dateUtil";
  import PendingOrderEdit from "./salesRevenue/PendingOrderEdit";
  import ManualEditDialog from "./salesRevenue/ManualEditDialog";
  import RegionalAdjustEdit from "./salesRevenue/RegionalAdjustEdit";
  import EditLogDialog from "./salesRevenue/EditLogDialog";
  import AdjustLogDialog from "./salesRevenue/AdjustLogDialog";
  import BpImportDialog from "./salesRevenue/BpImportDialog";
  import LogisticsCycleDialog from "./salesRevenue/LogisticsCycleDialog";
  import ZeroOrderDialog from "./salesRevenue/ZeroOrderDialog";
  import RelatedRatioDialog from "./salesRevenue/RelatedRatioDialog";
  import ExcludeImportDialog from "./salesRevenue/ExcludeImportDialog";
  import ExcludeLogDialog from "./salesRevenue/ExcludeLogDialog";
  import SalesRevenueDetailDialog from "./salesRevenue/SalesRevenueDetailDialog";
  import SalesRevenueDetailDownload from "./salesRevenue/SalesRevenueDetailDownload";

  export default {
    name: "SalesRevenueSummaryList",
    components: {
      PendingOrderEdit,
      ManualEditDialog,
      RegionalAdjustEdit,
      EditLogDialog,
      AdjustLogDialog,
      BpImportDialog,
      LogisticsCycleDialog,
      ZeroOrderDialog,
      RelatedRatioDialog,
      ExcludeImportDialog,
      ExcludeLogDialog,
      SalesRevenueDetailDialog,
      SalesRevenueDetailDownload,
    },
    data() {
      return {
        status: "empty",
        downLoadLoading: false,
        tableData: [],
        orgTree: [],
        hoverRow: null,
        filter: {
          beginTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
          reportType: 2,
        },
      };
    },
    methods: {
      getList() {
        if (this.filter.beginTime === "" || this.filter.beginTime == null) {
          return this.$message.error("报表月份不可为空!");
        }
        this.status = "loading";
        this.$http
          .get("basic", "sd/salesRevenueReport/summary", this.filter)
          .then(resp => {
            const rows = (resp && resp.rows) ? resp.rows : [];
            this.tableData = rows;
            this.orgTree = (resp && resp.orgTree) ? resp.orgTree : [];
            if (rows.length === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          })
          .catch(() => {
            this.status = "error";
          });
      },
      openDownload() {
        if (this.tableData.length === 0) {
          return this.$message.warning("暂无报表数据，请先查询.");
        }
        this.$refs.downloadDialog.open(this.orgTree, this.tableData, this.filter);
      },
      downLoadFile() {
        this.downLoadLoading = true;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportSummary", this.tableData)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downLoadLoading = false;
          })
          .catch(() => {
            this.downLoadLoading = false;
          });
      },
      handleCommand(command) {
        switch (command) {
          case "pendingOrder":
            this.$refs.pendingOrderEdit.open();
            break;
          case "manualEdit":
            this.$refs.manualEdit.open();
            break;
          case "editLog":
            this.$refs.editLog.open();
            break;
          case "adjustLog":
            this.$refs.adjustLog.open();
            break;
          case "bpImport":
            this.$refs.bpImport.open();
            break;
          case "logisticsCycle":
            this.$refs.logisticsCycle.open();
            break;
          case "zeroOrder":
            this.$refs.zeroOrder.open();
            break;
          case "relatedRatio":
            this.$refs.relatedRatio.open();
            break;
        }
      },
      hasDetail(details) {
        return Array.isArray(details) && details.length > 0;
      },
      openDetail(title, details) {
        this.$refs.detailDialog.open(title, details);
      },
      handleCellMouseEnter(row, column) {
        // 仅当鼠标停留在"已签收"列时才记录该行，用于显示修改按钮
        if (column && column.property === "signedAmount") {
          this.hoverRow = row;
        }
      },
      handleCellMouseLeave(row, column) {
        if (column && column.property === "signedAmount" && this.hoverRow === row) {
          this.hoverRow = null;
        }
      },
      // 仅"组织明细行"（国内销售组 / 海外部门，level=3 的实际数据行）可做区域财务调整；小计/总计行不可
      isAdjustableRow(row) {
        if (!row) {
          return false;
        }
        const name = row.orgName || "";
        if (name.includes("小计") || name.includes("总计")) {
          return false;
        }
        // 海外行有 departmentId；国内销售组行为 departmentId 为空但有销售组名
        return row.level === 3;
      },
      firstDayOfMonth(dateStr) {
        if (!dateStr) {
          return "";
        }
        const d = new Date(dateStr);
        return dateUtil.format(new Date(d.getFullYear(), d.getMonth(), 1), "yyyy-MM-dd");
      },
      openRegionalAdjust(row) {
        // 统一按"组织名称（departmentName）"匹配调整；后端汇总按 orgName 匹配，departmentId 仅作记录字段
        this.$refs.regionalAdjust.open({
          departmentId: row.departmentId !== null && row.departmentId !== undefined && row.departmentId !== "" ? Number(row.departmentId) : null,
          departmentName: row.orgName,
          periodDate: this.firstDayOfMonth(this.filter.beginTime),
        });
      },
      summaryRowClassName({ row }) {
        const name = row.orgName || "";
        if (name.includes("小计") || name.includes("总计")) {
          return "summary-row";
        }
        return "";
      },
      summaryRowStyle({ row }) {
        const name = row.orgName || "";
        if (name.includes("小计") || name.includes("总计")) {
          return {
            "font-weight": "bold",
            "font-size": "15px",
            "background-color": "#f5f7fa",
          };
        }
        return {};
      },
      openExclude() {
        this.$refs.exclude.open();
      },
      openExcludeLog() {
        this.$refs.excludeLog.open();
      },
    },
  };
</script>

<style scoped>
  .vm-search {
    margin: 10px;
  }
  .amount-link {
    color: #2d8cf0;
    font-weight: bold;
    cursor: pointer;
  }
  .amount-link:hover {
    text-decoration: underline;
  }
  .adjust-red {
    color: #f56c6c !important;
    font-weight: bold;
  }
  :deep(.summary-row) {
    font-weight: bold;
    font-size: 15px;
    background: #f5f7fa;
  }
  :deep(.summary-row) td {
    font-weight: bold;
    font-size: 15px;
    color: #303133;
  }
</style>
